export enum RoleEnum {
  User = 'user',
  Admin = 'admin',
  UserAdmin = 'useradmin',
  RolesAdmin = 'rolesadmin',
  ConfigurationAdmin = 'configurationadmin',
  RecipeRead = 'reciperead',
  RecipeWrite = 'recipewrite',
  RecipeAdmin = 'recipeadmin',
  ConversionRead = 'conversionread',
  PurchaseOrderRead = 'purchaseorderread',
  PurchaseOrderWrite = 'purchaseorderwrite',
  TransactionRead = 'transactionread',
  TransactionWrite = 'transactionwrite',
  TransactionAdmin = 'transactionadmin',
  StockRead = 'stockread',
  StockWrite = 'stockwrite',
  SourceTransactionRead = 'sourcetransactionread',
  StockCountRead = 'stockcountread',
  StockCountWrite = 'stockcountwrite',
  StockLocationRead = 'stocklocationread',
  StockLocationWrite = 'stocklocationwrite',
  StockListRead = 'stocklistread',
  StockListWrite = 'stocklistwrite',
  StockCountScheduleRead = 'stockcountscheduleread',
  StockCountScheduleWrite = 'stockcountschedulewrite',
  StockCountAdmin = 'stockcountadmin',
  ItemRead = 'itemread',
  ReportRead = 'reportread',
  TransferWrite = 'transferwrite',
  TransferRead = 'transferread',
  NotificationWrite = 'notificationwrite',
  CategoryAdmin = 'categoryadmin',
  PurchaseOrderAdjustmentsWrite = 'purchaseorderadjustmentswrite',
  DailyWasteCheckSheetRead = 'dailywastechecksheetsread',
  DailyWasteCheckSheetWrite = 'dailywastechecksheetwrite',
  MadeInStoreRead = 'madeinstoreread',
  MadeInStoreWrite = 'madeinstorewrite',
  CreateItemsAndRecipes = 'createitemsandrecipes',
  ManualTransactionCostPriceWrite = 'manualtransactioncostpricewrite',
  IncomingTransferWrite = 'incomingtransferwrite',
  OutgoingTransferWrite = 'outgoingtransferwrite',
  StockCountDelete = 'stockcountdelete',
  AutomatedTasks = 'automatedtasks',
  InvoiceReconciliationRead = 'invoicereconciliationread',
  InvoiceReconciliationAdmin = 'invoicereconciliationadmin',
  InvoiceReconciliationWrite = 'invoicereconciliationwrite',
  AuditAdministrator = 'auditadministrator',
  AuditRead = 'auditread',
}
